// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"zaa-z"};